<template>
  <v-container
    fill-height
    align-content-start
    class="app-section-width pa-0"
  >
    <v-row align-items="center" justify-content="center" class="pb-6">
      <v-img
        height="230"
        width="412"
        aspect-ratio="16/9"
        :src="page.coverImageUrl"
      >
        <div class="image-overlay"></div>
      </v-img>
    </v-row>
    <component :is="pageComponent" />
  </v-container>
</template>
<script>
import { mapState } from 'vuex'
import { pageTypes } from '@/config'

export default {
  data () {
    return {
      scrollPosition: 0,
      scrollElement: null,
      mainOriginalPaddingStyle: null,
    }
  },
  mounted () {
    if (this.$vuetify.breakpoint.xs) {
      const appScrollSection = document.getElementsByClassName('app-scroll-section')[0]
      const main = document.getElementsByTagName('main')[0]
      this.changeAppBarElementsColorToWhite()
      this.changeAppBarColorToTransparent()
      this.mainOriginalPaddingStyle = main.style.padding
      main.style.paddingTop = 0
      this.scrollElement = appScrollSection
      this.scrollElement.addEventListener('scroll', this.updateScroll)
    }
  },
  methods: {
    updateScroll () {
      const appbarHeight = 56
      const header = document.getElementsByTagName('header')[0]
      this.scrollPosition = this.scrollElement.scrollTop
      if (this.scrollPosition > appbarHeight) {
        header.classList.remove('background-color--transparent')
        header.classList.add('background-color--custom-white')
        this.resetColorAppBarElements()
      }
      else {
        header.classList.remove('background-color--custom-white')
        header.classList.add('background-color--transparent')
        this.changeAppBarElementsColorToWhite()
      }
    },
    changeAppBarColorToTransparent () {
      const header = document.getElementsByTagName('header')[0]
      header.classList.remove('white')
      header.classList.add('elevation-0')
      header.classList.add('background-color--transparent')
    },
    resetAppBarColor () {
      const header = document.getElementsByTagName('header')[0]
      header.classList.remove('background-color--transparent')
      header.classList.remove('background-color--custom-white')
      header.classList.remove('elevation-0')
      header.classList.add('white')
    },
    changeAppBarElementsColorToWhite () {
      const headerIcons = document.querySelectorAll('header > div.v-toolbar__content > button > span > i')
      const spanHeader = document.querySelector('header > div.v-toolbar__content > span')
      for (let headerIcon of headerIcons) {
        headerIcon.classList.add('white-color')
        headerIcon.classList.remove('primary--text')
        headerIcon.classList.remove('text--darken-1')
      }
      spanHeader.classList.add('white-color')
      spanHeader.classList.remove('primary--text')
      spanHeader.classList.remove('text--darken-1')
    },
    resetColorAppBarElements () {
      const headerIcons = document.querySelectorAll('header > div.v-toolbar__content > button > span > i')
      const spanHeader = document.querySelector('header > div.v-toolbar__content > span')
      for (let headerIcon of headerIcons) {
        headerIcon.classList.remove('white-color')
        headerIcon.classList.add('primary--text')
        headerIcon.classList.add('text--darken-1')
      }
      spanHeader.classList.remove('white-color')
      spanHeader.classList.add('primary--text')
      spanHeader.classList.add('text--darken-1')
    },
  },
  beforeDestroy () {
    if (this.$vuetify.breakpoint.xs) {
      const main = document.getElementsByTagName('main')[0]
      this.resetAppBarColor()
      this.resetColorAppBarElements()
      main.style.padding = this.mainOriginalPaddingStyle
      this.scrollElement.removeEventListener('scroll', this.updateScroll)
    }
  },
  computed: {
    ...mapState({
      page: state => state.pages.page,
    }),
    pageComponent () {
      if (!this.page) return null
      let componentName = null
      switch (this.page.type) {
      case pageTypes.CONTENT:
        componentName = `${ this.page.type.toLowerCase() }Page`
        break
      case pageTypes.SERVICE:
        componentName = this.page.type.toLowerCase()
        break
      default:
        componentName = this.page.type.toLowerCase()
        break
      }
      return componentName
    },
  },
  components: {
    contentPage: () => import('@/components/view-components/webapp-pages/page-types/Content.vue'),
    service: () => import('@/components/view-components/webapp-pages/page-types/Service.vue'),
  },
}
</script>
<style lang="scss">
.title-row {
  padding: 30px 12px 5px;
}

.background-color--transparent {
  background-color: transparent !important;
}

.background-color--custom-white {
  background-color: white !important;
}

.padding--none {
  padding: 0px !important;
}

.white-color {
  color: white !important;
}

.v-image {
  position: relative;
}
.image-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  border-radius: 10px 10px 0px 0px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.60) 8.09%, rgba(0, 0, 0, 0.00) 38.73%, rgba(0, 0, 0, 0.00) 59.79%, rgba(0, 0, 0, 0.60) 100%);
}
</style>